"use client";

import { create } from "zustand";

const STORAGE_KEY = "atech-reporting-device-id";

type ReportingDeviceState = {
  selectedDeviceId: string;
  setSelectedDeviceId: (deviceId: string) => void;
};

function readInitialDeviceId(): string {
  try {
    return localStorage.getItem(STORAGE_KEY) ?? "";
  } catch {
    return "";
  }
}

export const useReportingDeviceStore = create<ReportingDeviceState>((set) => ({
  selectedDeviceId: readInitialDeviceId(),
  setSelectedDeviceId: (deviceId) => {
    try {
      if (deviceId) {
        localStorage.setItem(STORAGE_KEY, deviceId);
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch {
      /* ignore */
    }
    set({ selectedDeviceId: deviceId });
  },
}));
